export const translatedAnswers: Record<string, Record<string, string>> = {
   
}

export const specialMappedQuestions = new Set([

])
